module.exports = __webpack_public_path__ + "static/media/perfil.2707fcd3.png";